import router from "@/router";
import { setSessionData } from "@/utils/sessionData.js";
const state = {
  token: "",
  userInfo: {},
  userInfo2: {},
  focusType: "",
  headFile: "",
  BadgeNumber: "",
  LedgerDetail: {},
  details: false
};

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token;
    localStorage.setItem("token", token);
    /* setSessionData('token', token) */
  },
  SET_USERINFO: (state, userInfo) => {
    state.userInfo = userInfo;
    localStorage.setItem("userInfo", userInfo);
  },
  SET_USERINFO2: (state, userInfo2) => {
    state.userInfo = userInfo;
    localStorage.setItem("userInfo2", userInfo2);
  },
  SET_FOCUSTYPE: (state, focusType) => {
    state.focusType = focusType;
    localStorage.setItem("focusType", focusType);
  },
  SET_HEADFILE: (state, headFile) => {
    state.headFile = headFile;
    localStorage.setItem("headFile", headFile);
  },
  SET_BADGENUMBER: (state, BadgeNumber) => {
    state.BadgeNumber = BadgeNumber;
    localStorage.setItem("BadgeNumber", BadgeNumber);
  },
  SET_LEDGERDETAIL: (state, LedgerDetail) => {
    state.LedgerDetail = LedgerDetail;
    setSessionData("LedgerDetail", LedgerDetail);
  },
  SET_Details: (state, details) => {
    state.details = details;
  }
};

const actions = {
  // user logout
  logout() {
    // removeSessionData('token')
    localStorage.removeItem("token");
    localStorage.removeItem("userInfo");
    router.push("/");
  },
  setToken(commit, token) {
    commit.commit("SET_TOKEN", token);
  },
  setUserInfo(commit, userInfo) {
    commit.commit("SET_USERINFO", userInfo);
  },
  setUserInfo2(commit, userInfo2) {
    commit.commit("SET_USERINFO2", userInfo2);
  },
  focusType(commit, focusType) {
    commit.commit("SET_FOCUSTYPE", focusType);
  },
  headFile(commit, headFile) {
    commit.commit("SET_HEADFILE", headFile);
  },
  BadgeNumber(commit, BadgeNumber) {
    commit.commit("SET_BADGENUMBER", BadgeNumber);
  },
  LedgerDetail(commit, LedgerDetail) {
    commit.commit("SET_LEDGERDETAIL", LedgerDetail);
  },
  SetDetails(commit, details) {
    commit.commit("SET_Details", details);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
